package com.patronat.top.dto.venues

import kotlinx.serialization.Serializable

@Serializable
data class VenueLocation(
    val address: String,
    val city: String? = null,
    val region: String? = null,
    val country: String = "Ukraine",
    val coordinates: GeoCoordinates? = null
)

@Serializable
data class GeoCoordinates(
    val latitude: Double,
    val longitude: Double
)
